import { render } from "./BioLinks.vue?vue&type=template&id=20253338&ts=true"
import script from "./BioLinks.vue?vue&type=script&lang=ts"
export * from "./BioLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__